import botdash from "../../../assets/docs/bubbles/botdash.png";
import botmbeed from "../../../assets/docs/bubbles/botmbeed.png";
import dashboard from "../../../assets/docs/bubbles/dashboard.png";
import script from "../../../assets/docs/bubbles/script.gif";

const jaanoBubbleIntegration = {
  platform: "Bubble",
  chatbot: "Jaano.ai",
  desc: `Integrating your Jaano.ai chatbot with Bubble allows you to easily add conversational AI to your Bubble applications. 
  By embedding a simple script, you can enable real-time interactions, automate responses, and provide 24/7 support directly within your web app — no coding required.`,
  steps: [
    {
      title: "Step 1: Set Up Your Jaano.ai Chatbot",
      instructions: [
        "Sign in to your Jaano.ai dashboard.",
        "Create a new bot or select an existing one.",
        "Train your bot using supported input types such as text snippets, URLs or PDFs.",
        "After training, navigate to the 'Deploy' → 'Embed' tab in the bot's settings.",
      ],
      images: [dashboard, botdash],
    },
    {
      title: "Step 2: Copy Your Jaano.ai Embed Script",
      instructions: [
        "In the Embed section of your bot, choose either 'Embed a chat bubble' or 'Embed directly using iframe'.",
        "Click 'Copy Script' to copy your bot’s embed code.",
        "This script will add a floating chatbot bubble or iframe to your site.",
      ],
      images: [botmbeed, script],
    },
    {
      title: "Step 3: Embed Jaano.ai Chatbot into Your Bubble App",
      instructions: [
        "Login to your Bubble dashboard.",
        "Select the app you want to embed the chatbot in and click 'Edit' or 'Launch Editor'.",
        "In the Bubble Editor, go to 'Visual Elements' and drag the HTML element to your desired section.",
        "Double-click the HTML element to open the code editor.",
        "Paste the copied Jaano.ai embed script.",
        "Click 'Preview' to test the chatbot.",
      ],
    },
    {
      title: "🎉 Success",
      instructions: [
        "You should now see the Jaano.ai chatbot active on your Bubble app, typically floating in the bottom corner.",
      ],
    },
    {
      title: "🛠️ Optional: Customize Bot Appearance",
      instructions: [
        "Go to 'Jaano.ai Dashboard → Select Bot → Settings → Chat Interface'.",
        "Change the color theme,  position, and other appearance options.",
      ],
    },
  ],
  notes: {
    demo: "Ask if a demo Bubble project or iframe vs script integration is needed.",
  },
};

export default jaanoBubbleIntegration;
